import React, { useMemo } from "react";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import { type IFileUpload } from "@musicfy/utils/hooks/useStorage";

import AudioPlayer from "./AudioPlayer";
import Icon from "./Icon";

const UploadedFile: React.FC<{
  uploadedFile: IFileUpload;
  index?: number;
  onDelete?: (index?: number) => void;
  uploadProgress: number;
}> = ({ uploadedFile, onDelete, index, uploadProgress }) => {
  const isUploading = uploadProgress < 100;

  const audioSrc = useMemo(() => {
    return URL.createObjectURL(uploadedFile.file);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedFile.path]);

  return (
    <div className="w-full bg-white/5 px-5 py-4 rounded-12 border border-white/10">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-4 w-[50vw] lg:w-[40vw]">
          <div className="w-fit rounded-full bg-white/15">
            <AudioPlayer audioSrc={audioSrc} type="circle" />
          </div>
          <div className="truncate">{uploadedFile.filename}</div>
        </div>

        {isUploading && (
          <div className="flex h-10 w-10 p-2 items-center justify-center">
            <CircularProgressbar
              value={uploadProgress || 0}
              styles={buildStyles({
                pathColor: "#0DF9A4",
                trailColor: "transparent",
              })}
              strokeWidth={16}
            />
          </div>
        )}
        {!isUploading && (
          <div className="flex items-center gap-6">
            <Icon name="check-circle" className="!w-5 !h-5 lg:!block !hidden" />
            <div
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation();
                onDelete?.(index);
              }}
            >
              <Icon name="trash" className="cursor-pointer w-5 h-5" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadedFile;
